import React, { useState, useEffect, useCallback } from 'react';
import { TextField, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const ContactInfoForm = ({
  name: initialName,
  setName,
  phone: initialPhone,
  setPhone,
  email: initialEmail,
  setEmail,
  isSender = false,
}) => {
  const { t } = useTranslation();

  const [name,  setLocalName]  = useState(initialName  ?? '');
  const [phone, setLocalPhone] = useState(initialPhone ?? '');
  const [email, setLocalEmail] = useState(initialEmail ?? '');

  // Sync if parent re-initializes (e.g. modal opens with different delivery)
  useEffect(() => { setLocalName(initialName   ?? ''); }, [initialName]);
  useEffect(() => { setLocalPhone(initialPhone ?? ''); }, [initialPhone]);
  useEffect(() => { setLocalEmail(initialEmail ?? ''); }, [initialEmail]);

  const handleNameBlur  = useCallback(() => setName?.(name),   [setName,  name]);
  const handlePhoneBlur = useCallback(() => setPhone?.(phone), [setPhone, phone]);
  const handleEmailBlur = useCallback(() => setEmail?.(email), [setEmail, email]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          size="small"
          label={isSender ? (t('delivery.senderName') || 'Your Name') : (t('delivery.recipientName') || 'Recipient Name')}
          placeholder="John Doe"
          value={name}
          onChange={(e) => setLocalName(e.target.value)}
          onBlur={handleNameBlur}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          size="small"
          label={isSender ? (t('delivery.senderPhone') || 'Your Phone') : (t('delivery.recipientPhone') || 'Recipient Phone')}
          placeholder="+358 40 123 4567"
          value={phone}
          onChange={(e) => setLocalPhone(e.target.value)}
          onBlur={handlePhoneBlur}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          size="small"
          label={isSender ? (t('delivery.senderEmail') || 'Your Email') : (t('delivery.recipientEmail') || 'Recipient Email')}
          placeholder="john@example.com"
          type="email"
          value={email}
          onChange={(e) => setLocalEmail(e.target.value)}
          onBlur={handleEmailBlur}
        />
      </Grid>
    </Grid>
  );
};